import * as React from 'react';

export class ToolsHeaderSvg extends React.Component<{}> {

  render() {
    return (
      <svg viewBox="0 0 67 50">
        <path
            d="M62.789,5.553H39.663A2.277,2.277,0,0,0,37.388,3.5H33.8a2.281,2.281,0,0,0-2.3,2.259v8.8a2.281,2.281,0,0,0,2.3,2.26h3.592a2.277,2.277,0,
            0,0,2.275-2.053h4.152V27.105H42.263a.5.5,0,0,0-.5.5V43a.5.5,0,0,0,.5.5h7.184a.5.5,0,0,0,.5-.5V27.605a.5.5,0,0,
            0-.5-.5H47.9V14.763h8.993a.5.5,0,0,0,.5-.5,5.332,5.332,0,0,1,5.4-5.247.5.5,0,0,0,.5-.5V6.053A.5.5,0,0,0,62.789,5.553Zm-24.1.5v8.5a1.28,
            1.28,0,0,1-1.3,1.26H33.8a1.28,1.28,0,0,1-1.3-1.26v-8.8A1.28,1.28,0,0,1,33.8,4.5h3.592a1.28,1.28,0,0,1,1.3,1.259ZM48.947,
            28.105V42.5H42.763V28.105h6.184Zm-4.132-1V14.763H46.9V27.105ZM62.289,8.035a6.335,6.335,0,0,0-5.881,5.728H39.685V6.553h22.6Z"
        />
        <path
            d="M17.24,43.946h0a3.192,3.192,0,0,1-3.188-3.2l.009-18.366a9.237,9.237,0,0,1-6.045-8.709,9.4,9.4,0,0,1,6.451-8.85.5.5,0,0,
            1,.654.47l.075,6.031L17.37,13.5l2.04-2.04.008-6.1a.5.5,0,0,1,.207-.4.493.493,0,0,1,.447-.071,9.243,9.243,0,0,1,6.422,8.819h0A9.229,
            9.229,0,0,1,20.43,22.4V40.754a3.189,3.189,0,0,1-3.191,3.192Zm0-1h0a2.189,2.189,0,0,0,2.192-2.192V22.042a.5.5,0,0,1,.346-.475,8.262,
            8.262,0,0,0,.641-15.484L20.41,11.67a.5.5,0,0,1-.147.353l-2.539,2.539a.5.5,0,0,1-.707,0L14.34,11.886a.5.5,0,0,
            1-.147-.347l-.068-5.526a8.4,8.4,0,0,0-5.114,7.659,8.238,8.238,0,0,0,5.7,7.877.5.5,0,0,1,.346.475l-.009,18.723a2.194,2.194,0,0,
            0,.641,1.556,2.171,2.171,0,0,0,1.548.643Z"
        />
      </svg>
    )
  }
}